(function () {
    'use strict';

    angular
        .module('gov.directives')
        .directive('govCompile', directive);

    directive.$inject = ['$compile'];

    /**
     * Directive to compile and render the HTML contained in the passed attribute's model.
     * Allows to compile directives contained in a model.
     *   e.g. <div gov-compile="myModele"></div>
     */
    function directive($compile) {
        return function(scope, element, attrs) {
            scope.$watch(
                function(scope) {

                    // watch the 'gov-compile' expression for changes
                    return scope.$eval(attrs.govCompile);
                },
                function (value) {
                  element.html(value);

                  $compile(element.contents())(scope);
                }
            );
        };
    }
})();
